import React from 'react';

import GridItem from '../GridItem';

import styles from './Grid.module.css';

const Grid = ({ elX, elY }) => (
  <div className={`${styles.grid} hidden lg:grid`}>
    {items.map((item, i) => (
      <GridItem
        item={item}
        index={i}
        // eslint-disable-next-line react/no-array-index-key
        key={`hero-item-${i}`}
        posX={elX}
        posY={elY}
      />
    ))}
  </div>
);

const items = [
  {
    img: {
      src: '/static/img/website/big/products/image/hero/img/bounding-box-2.jpg',
      alt: ''
    },
    svg: {
      src: '/static/img/website/big/products/image/hero/svg/bounding-box-2.svg',
      alt: ''
    }
  },
  {
    img: {
      src: '/static/img/website/big/products/image/hero/img/polygon-2.jpg',
      alt: ''
    },
    svg: {
      src: '/static/img/website/big/products/image/hero/svg/polygon-2.svg',
      alt: ''
    }
  },
  {
    img: {
      src: '/static/img/website/big/products/image/hero/img/point-1.jpg',
      alt: ''
    },
    svg: {
      src: '/static/img/website/big/products/image/hero/svg/point-1.svg',
      alt: ''
    }
  },
  {
    img: {
      src: '/static/img/website/big/products/image/hero/img/cuboid-2.jpg',
      alt: ''
    },
    svg: {
      src: '/static/img/website/big/products/image/hero/svg/cuboid-2.svg',
      alt: ''
    }
  },
  {
    img: {
      src: '/static/img/website/big/products/image/hero/img/polygon-1.jpg',
      alt: ''
    },
    svg: {
      src: '/static/img/website/big/products/image/hero/svg/polygon-1.svg',
      alt: ''
    }
  },
  {
    img: {
      src: '/static/img/website/big/products/image/hero/img/point-2.jpg',
      alt: ''
    },
    svg: {
      src: '/static/img/website/big/products/image/hero/svg/point-2.svg',
      alt: ''
    }
  },
  {
    img: {
      src: '/static/img/website/big/products/image/hero/img/lines-splines-1.jpg',
      alt: ''
    },
    svg: {
      src: '/static/img/website/big/products/image/hero/svg/lines-splines-1.svg',
      alt: ''
    }
  },
  {
    img: {
      src: '/static/img/website/big/products/image/hero/img/semantic-segmentation-2.jpg',
      alt: ''
    },
    svg: {
      src: '/static/img/website/big/products/image/hero/svg/semantic-segmentation-2.svg',
      alt: ''
    }
  },
  {
    img: {
      src: '/static/img/website/big/products/image/hero/img/cuboid-3.jpg',
      alt: ''
    },
    svg: {
      src: '/static/img/website/big/products/image/hero/svg/cuboid-3.svg',
      alt: ''
    }
  },
  {
    img: {
      src: '/static/img/website/big/products/image/hero/img/bounding-box-1.jpg',
      alt: ''
    },
    svg: {
      src: '/static/img/website/big/products/image/hero/svg/bounding-box-1.svg',
      alt: ''
    }
  },
  {
    img: {
      src: '/static/img/website/big/products/image/hero/img/cuboid-1.jpg',
      alt: ''
    },
    svg: {
      src: '/static/img/website/big/products/image/hero/svg/cuboid-1.svg',
      alt: ''
    }
  },
  {
    img: {
      src: '/static/img/website/big/products/image/hero/img/semantic-segmentation-1.jpg',
      alt: ''
    },
    svg: {
      src: '/static/img/website/big/products/image/hero/svg/semantic-segmentation-1.svg',
      alt: ''
    }
  }
];

export default Grid;
